const _i18n_alert = {
  ip_check : {
    EN: `Incorrect IP format`,
    KO: `IP 형식이 올바르지 않습니다.`,
    JP: `不正な IP 形式`
  },
  domain_check : {
    EN: `Incorrect domain format`,
    KO: `도메인 형식이 올바르지 않습니다.`,
    JP: `不正なドメイン形式`
  }
};

const i18n_toastr = { _i18n_alert }

export default i18n_toastr